import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { EventsService } from '../../services/events-services';
import { Router } from '@angular/router';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { AddEventComponent } from '../add-event/add-event.component';
import { GetEventDetailsComponent } from '../get-event-details/get-event-details.component';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PagingService } from '../../../../shared/Services/PagingService';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';


@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.scss'],
})
export class GetEventsComponent extends BaseComponent implements OnInit {
  dateFrom: string;
  dateTo: string;
  form: FormGroup;

  constructor(
    public service: EventsService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    private paging: PagingService
  ) {
    super(route, service, paging);
  }

  ngOnInit() {
    this.intitForm();
    this.loadEntities();
  }

  intitForm() {
    this.form = this.fb.group({
      titleAR: [''],
    });
  }

  handleSearch() {
    if (!this.form.value.titleAR.trim() && !this.dateFrom && !this.dateTo) {
      this.toast.danger('برجاءاختيار الاسم او التاريخ لاتمام عمليةالبحث', 'رساله تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (this.form.value.titleAR.trim()) {
      let title = this.form.value.titleAR.trim();
      this.form.controls['titleAR'].setValue(title);
      serchTermArr.push(`titleAR:${title}`);
    }

    if (this.dateFrom) {
      let dateInput = document.getElementById('dateFrom') as HTMLInputElement;
      let modifiedDate = new Date(dateInput.value);
      let dateFrom = new Date(modifiedDate.toString().split('GMT')[0].concat('GMT+0000')).toISOString().split('T')[0];
      serchTermArr.push(`dateTime:>${dateFrom}`);
    }
    if (this.dateTo) {
      let dateInput = document.getElementById('dateTo') as HTMLInputElement;
      let modifiedDate = new Date(dateInput.value);
      let dateTo = new Date(modifiedDate.toString().split('GMT')[0].concat('GMT+0000')).toISOString().split('T')[0];
      serchTermArr.push(`dateTime:<${dateTo}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
  clearFilter() {
    this.dateTo = '';
    this.dateFrom = '';
    this.form.controls['titleAR'].setValue('');

    this.loadEntitiesWithFilter('');
  }
  addNewEvent() {
    this.diag
      .open(AddEventComponent, {
        dialogClass: 'custom-dialog-height',
      })
      .onClose.subscribe((res) => {
        if (res === 'true') {
          this.loadEntities();
        }
      });
  }

    delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }


  detail(model) {
    this.diag.open(GetEventDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model,
      },
    });
  }

  update(model) {
    const copymodel = {...model}
    this.diag
      .open(AddEventComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
